// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certificate-settings--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px; }\n  .certificate-settings--layout .certificate-settings--list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    max-width: 1200px; }\n", ""]);
// Exports
module.exports = exports;
